import { alpha } from "@mui/material";
import { Check } from "@opengov/react-capital-assets";
import React from "react";
import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiSwitch = {
  defaultProps: {
    checkedIcon: /* @__PURE__ */ React.createElement("span", { className: "MuiSwitch-thumb" }, /* @__PURE__ */ React.createElement(Check, { fontSize: "inherit" })),
    disableFocusRipple: true
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      var _a;
      return {
        fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
        height: "32px",
        width: "60px",
        ...ownerState.size === "medium" && {
          fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyLarge,
          height: "52px",
          width: "84px"
        },
        ".MuiSwitch-thumb": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.palette.common.white,
          borderRadius: "50%",
          boxShadow: "0px 1px 3px 0px rgba(19, 21, 23, 0.5)",
          border: `1px solid ${theme.palette.divider}`,
          height: "24px",
          width: "24px",
          ...ownerState.size === "medium" && {
            height: "32px",
            width: "32px"
          }
        },
        ".Mui-checked .MuiSwitch-thumb": {
          // Optional: `color="default"` has no palette entry, so the thumb keeps its default border instead of the render
          // throwing.
          borderColor: (_a = theme.palette[ownerState.color]) == null ? void 0 : _a.main
        },
        ".Mui-disabled .MuiSwitch-thumb, .Mui-disabled.Mui-checked .MuiSwitch-thumb": {
          boxShadow: "none",
          borderColor: theme.palette.action.disabled,
          color: theme.palette.text.secondary
        }
      };
    },
    switchBase: ({ theme, ownerState }) => ({
      color: theme.palette.action.active,
      ...ownerState.size === "medium" && {
        top: "6px",
        left: "6px",
        padding: "4px"
      },
      "&.Mui-checked.Mui-checked": {
        transform: "translateX(26px)",
        ...ownerState.size === "medium" && {
          transform: "translateX(32px)"
        },
        "&+.MuiSwitch-track": {
          opacity: 1
        },
        "&:hover": {
          backgroundColor: theme.palette.action.hover
        }
      },
      "&.Mui-disabled+.MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.action.disabledBackground
      },
      // action.hover is already translucent; alpha() would replace its opacity (0.04 → 0.85) and paint a solid ring.
      "&:hover": {
        backgroundColor: theme.palette.action.hover
      },
      "&.Mui-focusVisible, &:focus-visible": {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: "-2px",
        backgroundColor: alpha(theme.palette.common.white, 0.95)
      }
    }),
    track: ({ theme }) => ({
      borderRadius: "14px",
      backgroundColor: theme.palette.action.disabled,
      opacity: 1
    })
  }
};
export {
  MuiSwitch
};
//# sourceMappingURL=MuiSwitch.js.map
